import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoryUnreadCountQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type StoryUnreadCountQuery = { __typename?: 'RootQueryType', fetchStoryUnreadCount: { __typename?: 'StoryUnreadCount', storyId: string, storySid: string, storyDatabaseId: any, unreadCount: number } };


export const StoryUnreadCountDocument = gql`
    query storyUnreadCount($id: ID!) {
  fetchStoryUnreadCount(storyId: $id) {
    storyId
    storySid
    storyDatabaseId
    unreadCount
  }
}
    `;

/**
 * __useStoryUnreadCountQuery__
 *
 * To run a query within a React component, call `useStoryUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryUnreadCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStoryUnreadCountQuery(baseOptions: Apollo.QueryHookOptions<StoryUnreadCountQuery, StoryUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoryUnreadCountQuery, StoryUnreadCountQueryVariables>(StoryUnreadCountDocument, options);
      }
export function useStoryUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoryUnreadCountQuery, StoryUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoryUnreadCountQuery, StoryUnreadCountQueryVariables>(StoryUnreadCountDocument, options);
        }
export type StoryUnreadCountQueryHookResult = ReturnType<typeof useStoryUnreadCountQuery>;
export type StoryUnreadCountLazyQueryHookResult = ReturnType<typeof useStoryUnreadCountLazyQuery>;
export type StoryUnreadCountQueryResult = Apollo.QueryResult<StoryUnreadCountQuery, StoryUnreadCountQueryVariables>;
export function refetchStoryUnreadCountQuery(variables: StoryUnreadCountQueryVariables) {
      return { query: StoryUnreadCountDocument, variables: variables }
    }